import React, { useState } from "react";
import { Box } from "@mui/material";

/**
 * Transforms standard video URLs (YouTube, Vimeo) into valid embed iframe URLs if needed.
 */
const getEmbedUrl = (url) => {
  try {
    if (url.includes("youtube.com/watch")) {
      const urlObj = new URL(url);
      const videoId = urlObj.searchParams.get("v");
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }
    if (url.includes("youtu.be/")) {
      const videoId = url.split("youtu.be/")[1]?.split("?")[0];
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }
    if (url.includes("vimeo.com/") && !url.includes("player.vimeo.com")) {
      const videoId = url.split("vimeo.com/")[1]?.split("?")[0];
      if (videoId) {
        return `https://player.vimeo.com/video/${videoId}`;
      }
    }
  } catch {
    // Return original url if parsing fails
  }
  return url;
};

const AnnouncementMedia = ({ mediaType = "NONE", mediaUrl = "", title = "" }) => {
  const [imageError, setImageError] = useState(false);

  if (!mediaUrl || mediaType === "NONE") {
    return null;
  }

  const isVideo = mediaType === "VIDEO";
  const isImage = mediaType === "IMAGE";

  const isEmbedVideo = isVideo && (mediaUrl.includes("youtube.com") || mediaUrl.includes("youtu.be") || mediaUrl.includes("vimeo.com") || mediaUrl.includes("player.vimeo.com"));

  const embedUrl = isEmbedVideo ? getEmbedUrl(mediaUrl) : "";

  return (
    <>
      {isImage && !imageError && (
        <Box
          sx={{
            width: "100%",
            bgcolor: "grey.900",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={mediaUrl}
            alt={title}
            onError={() => setImageError(true)}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "70vh",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      )}

      {isVideo && (
        <Box
          sx={{
            width: "100%",
            height: 260,
            bgcolor: "black",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {isEmbedVideo ? (
            <iframe
              src={embedUrl}
              title={title}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video controls playsInline style={{ width: "100%", height: "100%", objectFit: "contain" }}>
              <source src={mediaUrl} />
              Your browser does not support the video tag.
            </video>
          )}
        </Box>
      )}
    </>
  );
};

export default AnnouncementMedia;
